import React,{useEffect,useState} from 'react';
import * as Icon from "@phosphor-icons/react";

export default function SizeChart(props){

    const {closeModal,data} = props;

    const [activeSize, setActiveSize] = useState('')
    const [heightRange, setHeightRange] = useState({ min: 100, max: 200 });
    const [weightRange, setWeightRange] = useState({ min: 30, max: 90 });

    const calculateSize = (height, weight) => {
        if (height > 180 || weight > 70) {
            setActiveSize('2XL');
        } else if (height > 170 || weight > 60) {
            setActiveSize('XL');
        } else if (height > 160 || weight > 50) {
            setActiveSize('L');
        } else if (height > 155 || weight > 45) {
            setActiveSize('M');
        } else if (height > 150 || weight > 40) {
            setActiveSize('S');
        } else {
            setActiveSize('XS');
        }
    };

    const handleHeightChange = (values) => {
        if (Array.isArray(values)) {
            setHeightRange({ min: values[0], max: values[1] });
        }
        calculateSize(heightRange.max, weightRange.max)
    };

    const handleWeightChange = (values) => {
        if (Array.isArray(values)) {
            setWeightRange({ min: values[0], max: values[1] });
        }
        calculateSize(heightRange.max, weightRange.max)
    };
    
    return <>
        <div className="modal fade show" style={{ display: 'block',backgroundColor:"rgba(0, 0, 0,0.7)" }} onClick={closeModal}>
                <div className="fade show" onClick={e => e.stopPropagation()}></div>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content position-relative bg-white p-4" onClick={e => e.stopPropagation()}>
                        <button type="button" className="btn-close btn-close-black position-absolute top-0 end-0 m-3" onClick={closeModal}></button>
                        
                        <div className="heading">Size guide</div>
                            
                        <div className="list-size flex items-center gap-2 flex-wrap mt-3">
                            {/* {data?.sizes.map((item, index) => (
                                <div
                                    className={`size-item w-12 h-12 flex items-center justify-center text-button rounded-full bg-white border border-line ${activeSize === item ? 'active' : ''}`}
                                    key={index}
                                >
                                    {item}
                                </div>
                            ))} */}
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Size</th>
                                    <th>Bust</th>
                                    <th>Waist</th>
                                    <th>Low Hip</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>XS</td>
                                    <td>32</td>
                                    <td>24-25</td>
                                    <td>33-34</td>
                                </tr>
                                <tr>
                                    <td>S</td>
                                    <td>34-35</td>
                                    <td>26-27</td>
                                    <td>35-36</td>
                                </tr>
                                <tr>
                                    <td>M</td>
                                    <td>36-37</td>
                                    <td>28-29</td>
                                    <td>38-40</td>
                                </tr>
                                <tr>
                                    <td>L</td>
                                    <td>38-39</td>
                                    <td>30-31</td>
                                    <td>42-44</td>
                                </tr>
                                <tr>
                                    <td>XL</td>
                                    <td>40-41</td>
                                    <td>32-33</td>
                                    <td>45-47</td>
                                </tr>
                                <tr>
                                    <td>2XL</td>
                                    <td>42-43</td>
                                    <td>34-35</td>
                                    <td>48-50</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
    </>
  }